import React from "react"

const QuoteIcon: React.FC<{ isClosing?: boolean }> = ({
  isClosing = false,
}) => {
  return (
    <svg
      width="43"
      height="32"
      viewBox="0 0 43 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: isClosing ? "rotate(180deg)" : "rotate(0deg)" }}
    >
      <path
        d="M43 22.1699C43 23.5643 42.7244 24.854 42.1731 26.0392C41.6907 27.2244 41.0016 28.2702 40.1058 29.1765C39.2099 30.0131 38.1418 30.7102 36.9014 31.268C35.73 31.756 34.4896 32 33.1803 32C31.8021 32 30.5272 31.756 29.3558 31.268C28.1843 30.7102 27.1506 30.0131 26.2548 29.1765C25.359 28.2702 24.6354 27.2244 24.0841 26.0392C23.6018 24.854 23.3606 23.5643 23.3606 22.1699V9.41177C23.3606 6.76253 24.222 4.53159 25.9447 2.71896C27.7364 0.906319 29.9415 0 32.5601 0H39.1755V8.15686H34.2139C32.3534 8.15686 31.4231 9.20262 31.4231 11.2941V12.549C31.6987 12.4096 32.0088 12.3399 32.3534 12.3399C32.6979 12.2702 33.0425 12.2353 33.387 12.2353C36.2812 12.2353 38.5897 13.1765 40.3125 15.0588C42.1042 16.8715 43 19.2418 43 22.1699ZM19.6394 22.1699C19.6394 23.5643 19.3638 24.854 18.8125 26.0392C18.3301 27.2244 17.641 28.2702 16.7452 29.1765C15.8494 30.0131 14.7812 30.7102 13.5409 31.268C12.3694 31.756 11.129 32 9.81971 32C8.44151 32 7.16667 31.756 5.99519 31.268C4.82372 30.7102 3.79006 30.0131 2.89423 29.1765C1.9984 28.2702 1.27484 27.2244 0.723558 26.0392C0.241186 24.854 0 23.5643 0 22.1699V9.41177C0 6.76253 0.861378 4.53159 2.58413 2.71896C4.3758 0.906319 6.58093 0 9.19952 0H15.8149V8.15686H10.8534C8.99279 8.15686 8.0625 9.20262 8.0625 11.2941V12.549C8.33814 12.4096 8.64824 12.3399 8.99279 12.3399C9.33734 12.2702 9.68189 12.2353 10.0264 12.2353C12.9207 12.2353 15.2292 13.1765 16.9519 15.0588C18.7436 16.8715 19.6394 19.2418 19.6394 22.1699Z"
        fill="#FFDA66"
      />
    </svg>
  )
}

export default QuoteIcon
